/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollow = {
    properties: {
        leagues: {
            type: 'UserFollowLeagueList',
            isRequired: true,
        },
        teams: {
            type: 'UserFollowTeamList',
            isRequired: true,
        },
        players: {
            type: 'UserFollowPlayerList',
            isRequired: true,
        },
        matches: {
            type: 'UserFollowMatchList',
            isRequired: true,
        },
    },
} as const;
